import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, Renderer2, AfterViewInit, OnDestroy, PLATFORM_ID, inject } from '@angular/core';

@Directive({
  selector: '[appScrollProgress]',
  standalone: true
})
export class ScrollProgressDirective implements AfterViewInit, OnDestroy {
  private platformId = inject(PLATFORM_ID);
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);


  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('scroll', this.onScroll, true);
      window.addEventListener('resize', this.onScroll, true);
    }
    
    // Force an update immediately
    setTimeout(() => this.onScroll(), 100);
  }

  ngOnDestroy() {
    // Only remove listeners if they were added in the browser
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('scroll', this.onScroll, true);
      window.removeEventListener('resize', this.onScroll, true);
    }
  }

  private onScroll = (): void => {
    // Double-guard: Ensure we are in the browser and the element exists
    if (!isPlatformBrowser(this.platformId) || !this.el?.nativeElement) return;

    const container = this.el.nativeElement;
    
    // Server crashes here because it doesn't know what a 'rect' is
    const rect = container.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // 1. Calculate Progress
    const pixelsVisible = windowHeight - rect.top;
    const totalDistance = windowHeight + rect.height;
    let globalProgress = pixelsVisible / totalDistance;
    globalProgress = Math.max(0, Math.min(1, globalProgress));

    // 2. ANIMATE THE LINE
    const line = container.querySelector('.journey-line');
    if (line) {
        this.renderer.setStyle(line, 'height', `${globalProgress * 100}%`);
    }

    // 3. ANIMATE THE STEPS
    const steps = container.querySelectorAll('.process-step');
    steps.forEach((step: HTMLElement, index: number) => {
      const startThreshold = index * 0.12;
      let localProgress = (globalProgress - startThreshold) * 5;
      localProgress = Math.max(0, Math.min(1, localProgress));

      this.renderer.setStyle(step, 'opacity', `${localProgress}`);
      this.renderer.setStyle(step, 'transform', `translateY(${(1 - localProgress) * 50}px)`);
    });
  }
}